import { Link } from 'react-router-dom';
import { LOGO_URL, BRAND } from '@/mocks/brandData';

const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Services', href: '/services' },
  { label: 'About', href: '/about' },
  { label: 'San Antonio', href: '/location' },
];

export default function Footer() {
  return (
    <footer style={{ backgroundColor: '#1a1a18' }} className="text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-12 border-b border-white/8">

          <div className="md:col-span-4">
            <img src={LOGO_URL} alt="JC Cooks Catering & Chef Service" className="h-9 w-auto mb-5 brightness-0 invert opacity-90" />
            <p className="text-white/45 text-sm leading-relaxed max-w-xs mb-7">
              San Antonio&apos;s premier personal chef and catering service. Over 20 years of culinary excellence, crafted entirely from scratch.
            </p>
            <p className="text-[11px] font-semibold tracking-[0.15em] uppercase text-white/25 mb-4">Follow Along</p>
            <div className="flex gap-2.5">
              {[
                { href: BRAND.facebook, icon: 'ri-facebook-fill', label: 'Facebook' },
                { href: BRAND.twitter, icon: 'ri-twitter-x-fill', label: 'Twitter' },
                { href: BRAND.linkedin, icon: 'ri-linkedin-fill', label: 'LinkedIn' },
                { href: `mailto:${BRAND.email}`, icon: 'ri-mail-line', label: 'Email' },
              ].map((s) => (
                <a key={s.label} href={s.href} target={s.href.startsWith('http') ? '_blank' : undefined} rel="noopener noreferrer" aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center border border-white/10 rounded-full text-white/40 hover:border-jc-gold hover:text-jc-gold transition-all duration-200">
                  <i className={`${s.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <p className="text-[10px] font-bold tracking-[0.18em] uppercase text-jc-gold mb-5">Pages</p>
            <ul className="space-y-3">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <Link to={l.href} className="text-white/40 text-sm hover:text-white transition-colors duration-200">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-[10px] font-bold tracking-[0.18em] uppercase text-jc-gold mb-5">Credentials</p>
            <ul className="space-y-3">
              {['American Personal Chef Association', 'eWomenNetwork Member', 'Thumbtack Best of 2016', 'Thumbtack Best of 2017'].map((c) => (
                <li key={c} className="flex items-start gap-2">
                  <i className="ri-award-line text-jc-gold/60 text-xs mt-0.5 flex-shrink-0"></i>
                  <span className="text-white/40 text-sm">{c}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-[10px] font-bold tracking-[0.18em] uppercase text-jc-gold mb-5">Contact</p>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-2-line text-jc-gold/70 text-base mt-0.5 flex-shrink-0"></i>
                <address className="text-white/40 text-sm not-italic leading-relaxed">
                  {BRAND.address}<br />{BRAND.city}, {BRAND.state} {BRAND.zip}
                </address>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-phone-line text-jc-gold/70 text-base flex-shrink-0"></i>
                <a href={BRAND.phoneHref} className="text-white/40 text-sm hover:text-white transition-colors">{BRAND.phone}</a>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-mail-line text-jc-gold/70 text-base flex-shrink-0"></i>
                <a href={`mailto:${BRAND.email}`} className="text-white/40 text-sm hover:text-white transition-colors">{BRAND.email}</a>
              </div>
              <div className="pt-2">
                <a href="#quote" className="inline-flex items-center gap-2 px-5 py-2.5 bg-jc-gold text-jc-charcoal text-[10px] font-bold tracking-[0.15em] uppercase rounded-full hover:bg-white transition-all duration-300 whitespace-nowrap">
                  Request a Quote
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-7 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-white/20 text-xs">&copy; {new Date().getFullYear()} {BRAND.name}. All rights reserved.</p>
          <p className="text-white/15 text-xs">{BRAND.city}, {BRAND.state}</p>
        </div>
      </div>
    </footer>
  );
}
